const blue = {
  '+10': '#FFFFFF',
  '+9': '#EBF1F7',
  '+8': '#D6E3EF',
  '+7': '#C2D5E6',
  '+6': '#9EBFDC',
  '+3': '#6BA3D8',
  '+2': '#4A91D4',
  '+0': '#3372AD',
  primary: '#3372AD',
  '-3': '#105D98',
  '-5': '#00477D',
  '-7': '#0F2234',
  '-9': '#000000',
  background: '#F9FBFD',
  table: '#F9FDFF',
};

const green = {
  '+10': '#FFFFFF',
  '+9': '#E7F6F4',
  '+8': '#D6EEED',
  '+7': '#AEE2DF',
  '+6': '#81DBD4',
  '+3': '#53CFC6',
  '+2': '#37C5BB',
  '+0': '#30ABA3',
  primary: '#30ABA3',
  '-3': '#268982',
  '-5': '#1D6762',
  '-7': '#0D3734',
  '-9': '#000000',
  background: '#F2F5F7',
  table: '#F5FCFB',
};

const gray = {
  '+10': '#FFFFFF',
  '+9': '#F4F4F4',
  '+8': '#E0E0E0',
  '+7': '#C6C6C6',
  '+6': '#A8A8A8',
  '+3': '#8D8D8D',
  '+2': '#6F6F6F',
  '+0': '#525252',
  primary: '#525252',
  '-3': '#393939',
  '-5': '#262626',
  '-7': '#161616',
  '-9': '#000000',
  background: '#F2F5F7',
  table: '#F5FCFB',
};

const shadow = {
  modal: '0px 12px 32px 4px rgba(82, 82, 82, 0.56)',
  interactive: {
    default:
      '0px 1px 1px rgba(82, 82, 82, 0.1), 0px 2px 4px rgba(82, 82, 82, 0.1), 0px 1px 5px rgba(82, 82, 82, 0.08)',
    hover:
      '0px 0px 1px rgba(82, 82, 82, 0.1), 0px 4px 8px rgba(82, 82, 82, 0.1), 0px 2px 5px rgba(82, 82, 82, 0.1)',
    focus:
      '0px 0px 1px rgba(82, 82, 82, 0.1), 0px 3px 4px rgba(82, 82, 82, 0.1), 0px 2px 5px rgba(82, 82, 82, 0.1)',
    active:
      '0px 0px 4px rgba(82, 82, 82, 0.1), 0px 2px 6px rgba(82, 82, 82, 0.1), 0px 2px 5px rgba(82, 82, 82, 0.1)',
    disabled: '0px 0px 1px rgba(82, 82, 82, 0.4)',
  },
  container: {
    default:
      '0px 1px 4px rgba(82, 82, 82, 0.1), 0px 2px 8px 2px rgba(82, 82, 82, 0.1)',
    hover:
      '0px 1px 2px rgba(0, 0, 0, 0.1), 0px 2px 8px 2px rgba(82, 82, 82, 0.15)',
  },
};

const misc = {
  link: '#3C9DD7',
  tableHeader: '#F5F5F0', // Weird color that Bill suggested that does not fit into the palette
  transparent: 'rgb(0, 0, 0, 0)',
};

const accent = {
  orange: {
    '+4': '#FDEBDD',
    '+3': '#FBCDAB',
    '+2': '#FAB989',
    '+1': '#F9A970',
    '+0': '#F89B57',
    primary: '#F89B57',
    '-1': '#DE8B4E',
    '-2': '#AD6C3C',
  },
  rose: {
    '+4': '#FADEEC',
    '+3': '#F3ADCF',
    '+2': '#EE8CBC',
    '+1': '#EB73AE',
    '+0': '#E85BA0',
    primary: '#E85BA0',
    '-1': '#D0518F',
    '-2': '#A13F6F',
  },
  lavender: {
    '+4': '#F1DEFA',
    '+3': '#DEADF3',
    '+2': '#D08CEE',
    '+1': '#CB81ED',
    '+0': '#BD5BE8',
    primary: '#BD5BE8',
    '-1': '#A951D0',
    '-2': '#833FA1',
  },
};

const alert = {
  green: {
    '+3': '#EFFFF4',
    powder: '#EFFFF4',
    '+2': '#ACDCC0',
    light: '#ACDCC0',
    '+1': '#95CAAB',
    hover: '#95CAAB',
    '+0': '#5AB982',
    primary: '#5AB982',
    '-1': '#3E815A',
    dark: '#3E815A',
  },
  yellow: {
    '+3': '#FFF6DA',
    powder: '#FFF6DA',
    '+2': '#FFEAB6',
    light: '#FFEAB6',
    '+1': '#FFCD76',
    hover: '#FFCD76',
    '+0': '#FFB649',
    primary: '#FFB649',
    '-1': '#B77024',
    dark: '#B77024',
  },
  red: {
    '+3': '#FFF0F1',
    powder: '#FFF0F1',
    '+2': '#F9AAAA',
    light: '#F9AAAA',
    '+1': '#E58E8E',
    hover: '#E58E8E',
    '+0': '#F45656',
    primary: '#F45656',
    '-1': '#AA3C3C',
    dark: '#AA3C3C',
  },
};

const button = {
  green: {
    '+2': '#41CBBE',
    hover: '#41CBBE',
    '+0': '#30ABA3',
    primary: '#30ABA3',
    '-3': '#2C8982',
    focus: '#2C8982',
    '-5': '#216762',
    active: '#216762',
    '-7': '#96A7A6',
    disabled: '#96A7A6',
  },
  blue: {
    '+2': '#3D79B1',
    hover: '#3D79B1',
    '+0': '#3372AD',
    primary: '#3372AD',
    '-3': '#285B8A',
    focus: '#285B8A',
    '-5': '#1E4467',
    active: '#1E4467',
    '-7': '#959DA6',
    disabled: '#959DA6',
  },
  red: {
    '+2': '#F78080',
    hover: '#F78080',
    '+0': '#F45656',
    primary: '#F45656',
    '-3': '#C14648',
    focus: '#C14648',
    '-5': '#903536',
    active: '#903536',
    '-7': '#B19B9B',
    disabled: '#B19B9B',
  },
};

export default {
  white: '#FFFFFF',
  black: '#000000',
  primary: {
    blue,
    green,
    gray,
  },
  shadow,
  misc,
  accent,
  alert,
  button,
};
